import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import type { Crumb } from '@/lib/nav-trail';

/** مسارُ التنقّل — المنطقُ والسياق في `lib/nav-trail.ts` */
export function Breadcrumbs({ items }: { items: readonly Crumb[] }) {
  if (items.length < 2) return null;
  return (
    <nav className="crumbs no-print" aria-label="مسار التنقّل">
      <ol>
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${i}-${c.label}`}>
              {last
                ? <span className="crumbs__here" aria-current="page" title={c.label}>{c.label}</span>
                : c.to
                  ? <Link to={c.to} className="crumbs__link" title={c.label}>{c.label}</Link>
                  : c.onClick
                    ? <button type="button" className="crumbs__link" onClick={c.onClick} title={c.label}>{c.label}</button>
                    : <span className="crumbs__group" title={c.label}>{c.label}</span>}
              {!last && <ChevronLeft size={14} className="crumbs__sep" aria-hidden />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
